import { render } from "./GroupMessage.vue?vue&type=template&id=1ad1a086"
import script from "./GroupMessage.vue?vue&type=script&lang=js"
export * from "./GroupMessage.vue?vue&type=script&lang=js"

import "./GroupMessage.vue?vue&type=style&index=0&id=1ad1a086&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__